import {
  Coffee,
  Pause,
  Utensils,
  Droplets,
  Moon,
  Phone,
  Music,
  Zap,
  Activity,
  Smile,
  Timer,
  Dumbbell,
  HeartHandshake,
  PersonStanding,
  Sandwich,
  Cigarette,
  type LucideIcon,
} from "lucide-react";

export interface IQuickActivityIcon {
  value: string;
  label: string;
  icon: LucideIcon;
}

// `value` is the persisted lucide icon name (a contract); `label` holds an
// i18n key that consumers must resolve with t().
export const QUICK_ACTIVITY_ICONS: IQuickActivityIcon[] = [
  {
    value: "Coffee",
    label: "company:time_attendance.quick_activity_icons.tea_coffee",
    icon: Coffee,
  },
  {
    value: "Pause",
    label: "company:time_attendance.quick_activity_icons.short_break",
    icon: Pause,
  },
  {
    value: "Utensils",
    label: "company:time_attendance.quick_activity_icons.lunch",
    icon: Utensils,
  },
  {
    value: "Sandwich",
    label: "company:time_attendance.quick_activity_icons.snack",
    icon: Sandwich,
  },
  {
    value: "Droplets",
    label: "company:time_attendance.quick_activity_icons.water_break",
    icon: Droplets,
  },
  {
    value: "Moon",
    label: "company:time_attendance.quick_activity_icons.rest",
    icon: Moon,
  },
  {
    value: "Phone",
    label: "company:time_attendance.quick_activity_icons.phone_call",
    icon: Phone,
  },
  {
    value: "Music",
    label: "company:time_attendance.quick_activity_icons.music",
    icon: Music,
  },
  {
    value: "HeartHandshake",
    label: "company:time_attendance.quick_activity_icons.prayer",
    icon: HeartHandshake,
  },
  {
    value: "PersonStanding",
    label: "company:time_attendance.quick_activity_icons.walk",
    icon: PersonStanding,
  },
  {
    value: "Zap",
    label: "company:time_attendance.quick_activity_icons.quick_break",
    icon: Zap,
  },
  {
    value: "Activity",
    label: "company:time_attendance.quick_activity_icons.exercise",
    icon: Activity,
  },
  {
    value: "Smile",
    label: "company:time_attendance.quick_activity_icons.personal",
    icon: Smile,
  },
  {
    value: "Timer",
    label: "company:time_attendance.quick_activity_icons.timed_break",
    icon: Timer,
  },
  {
    value: "Dumbbell",
    label: "company:time_attendance.quick_activity_icons.gym",
    icon: Dumbbell,
  },
  {
    value: "Cigarette",
    label: "company:time_attendance.quick_activity_icons.smoke",
    icon: Cigarette,
  },
];
